import './polyfills';

import React from 'react';

import { createRoot } from 'react-dom/client';

import { initializeDatadogRum } from 'monitoring/datadog-rum';

import Root from './root.component';

const container = document.getElementById('root');

if (!container) {
  throw new Error("Root container '#root' was not found in index.html");
}

const root = createRoot(container);

void initializeDatadogRum();

root.render(<Root />);
